import styled from "styled-components";
import PageSection from "../PageSection";
import { StyledSectionProps } from "./Section.types";

export const StyledSection = styled(PageSection)<StyledSectionProps>`
	${({ viewport, theme, roundedCorners, backgroundColor }) => {
		const bgColor = {
			backgroundColor: theme.palette.hexForRole(backgroundColor),
		};

		const largeScreenStyle = {
			...(roundedCorners && {
				borderRadius: `calc(2 * ${theme.radii.xxl}) 0`,
			}),
			padding: `${theme.space["xxxl-3"]} 0`,
		};

		const smallScreenStyle = {
			...(roundedCorners && { borderRadius: `${theme.radii.xxl} 0` }),
			padding: `${theme.space.xxl} 0`,
		};

		const deviceSpecificStyle = viewport.greaterThan.lg
			? largeScreenStyle
			: smallScreenStyle;

		return { ...bgColor, ...deviceSpecificStyle };
	}}
`;
